export const COUNTRY_OPTIONS = [
  { value: "AT", labelKey: "lotteries.countries.austria" },
  { value: "BE", labelKey: "lotteries.countries.belgium" },
  { value: "DE", labelKey: "lotteries.countries.germany" },
  { value: "EE", labelKey: "lotteries.countries.estonia" },
  { value: "ES", labelKey: "lotteries.countries.spain" },
  { value: "FI", labelKey: "lotteries.countries.finland" },
  { value: "FR", labelKey: "lotteries.countries.france" },
  { value: "GR", labelKey: "lotteries.countries.greece" },
  { value: "HR", labelKey: "lotteries.countries.croatia" },
  { value: "IE", labelKey: "lotteries.countries.ireland" },
  { value: "IT", labelKey: "lotteries.countries.italy" },
  { value: "LT", labelKey: "lotteries.countries.lithuania" },
  { value: "LU", labelKey: "lotteries.countries.luxembourg" },
  { value: "LV", labelKey: "lotteries.countries.latvia" },
  { value: "NL", labelKey: "lotteries.countries.netherlands" },
  { value: "PT", labelKey: "lotteries.countries.portugal" },
  { value: "SI", labelKey: "lotteries.countries.slovenia" },
  { value: "SK", labelKey: "lotteries.countries.slovakia" },
  { value: "US", labelKey: "lotteries.countries.unitedStates" },
  { value: "GB", labelKey: "lotteries.countries.unitedKingdom" },
  { value: "CH", labelKey: "lotteries.countries.switzerland" },
  { value: "CZ", labelKey: "lotteries.countries.czechRepublic" },
  { value: "DK", labelKey: "lotteries.countries.denmark" },
  { value: "HU", labelKey: "lotteries.countries.hungary" },
  { value: "IS", labelKey: "lotteries.countries.iceland" },
  { value: "NO", labelKey: "lotteries.countries.norway" },
  { value: "PL", labelKey: "lotteries.countries.poland" },
  { value: "SE", labelKey: "lotteries.countries.sweden" },
  { value: "ZA", labelKey: "lotteries.countries.southAfrica" },
];

export const COUNTRY_LOTTERY_MAP = {
  AT: ["euromillions"],
  BE: ["euromillions"],
  CH: ["euromillions"],
  CZ: ["eurojackpot"],
  DE: ["eurojackpot"],
  DK: ["eurojackpot"],
  EE: ["eurojackpot"],
  ES: ["euromillions", "eurojackpot"],
  FI: ["eurojackpot"],
  FR: ["euromillions"],
  GB: ["euromillions"],
  GR: ["eurojackpot"],
  HR: ["eurojackpot"],
  HU: ["eurojackpot"],
  IE: ["euromillions"],
  IS: ["eurojackpot"],
  IT: ["eurojackpot"],
  LT: ["eurojackpot"],
  LU: ["euromillions"],
  LV: ["eurojackpot"],
  NL: ["eurojackpot"],
  NO: ["eurojackpot"],
  PL: ["eurojackpot"],
  PT: ["euromillions"],
  SE: ["eurojackpot"],
  SI: ["eurojackpot"],
  SK: ["eurojackpot"],
  US: ["powerball", "megamillions"],
  ZA: ["southafricapowerball", "southafricapowerballplus"],
};

export const DEFAULT_COUNTRY_BY_LOTTERY = {
  powerball: "US",
  megamillions: "US",
  euromillions: "GB",
  eurojackpot: "DE",
  southafricapowerball: "ZA",
  southafricapowerballplus: "ZA",
};

export const normalizeCountryCode = (value) => {
  if (typeof value !== "string") {
    return "";
  }
  return value.toUpperCase().trim();
};

export const resolveCountryForLottery = (preferenceCountry, lotteryId) => {
  if (COUNTRY_OPTIONS.some((option) => option.value === preferenceCountry)) {
    return preferenceCountry;
  }
  return DEFAULT_COUNTRY_BY_LOTTERY[lotteryId] || "";
};

export const getCountryOption = (countryCode) => (
  COUNTRY_OPTIONS.find((option) => option.value === countryCode) || null
);

export const isSupportedCountryCode = (countryCode) => Boolean(getCountryOption(countryCode));

export const resolveDefaultLotteryForCountry = (countryCode, fallbackLotteryId = "powerball") => {
  const normalizedCountryCode = normalizeCountryCode(countryCode);
  const lotteryIds = COUNTRY_LOTTERY_MAP[normalizedCountryCode];
  if (!Array.isArray(lotteryIds) || lotteryIds.length === 0) {
    return fallbackLotteryId;
  }

  return lotteryIds[0] || fallbackLotteryId;
};
